// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__XCV7F","arrow":"Nav_arrow__wJ9yu","option":"Nav_option__owuV9"};